// @flow
import * as React from 'react';
import { translate } from 'react-i18next';
import styled from 'styled-components';
import CalendarToday from '@material-ui/icons/CalendarToday';
import DateRange from 'common/domain/DateRange';
import { Input } from 'statsradio/themes/v3/Stylesheet';
import LabeledInput from './LabeledInput';

export const DateRangeInput = styled(Input)`
  width: 340px;  
`;

const CalendarIcon = styled(CalendarToday)`
  font-size: 20px;
  margin-right: ${props => props.theme.V3.metrics.margin.small}px;
`;

export const FocusedDateRangeInput = styled(DateRangeInput)`
  border-color: ${props => props.theme.V3.colors.primary.normal};
  background-color: ${props => props.theme.V3.colors.form.fill};
`;

const SelectedCalendarIcon = styled(CalendarIcon)`
  color: ${props => props.theme.V3.colors.primary.normal};
`;

interface Props {
  dateRange: DateRange;
  label?: string | React.Element<any> ;
  name: string;
  onClick: (any) => void;
  focused: boolean;

  t: any;
}

export function DateRangePickerInput({ dateRange, name, label, onClick, focused, t }: Props) {
  function Content() {
    return (
      <React.Fragment>
        { focused ?
          <FocusedDateRangeInput onClick={onClick}>
            <SelectedCalendarIcon fontSize="inherit" />
            {t('date.dateRangeShortMonth', { from: dateRange.from, to: dateRange.to, separator: ' - ' })}
          </FocusedDateRangeInput>
        :
          <DateRangeInput onClick={onClick}>
            <CalendarIcon fontSize="inherit" />
            {t('date.dateRangeShortMonth', { from: dateRange.from, to: dateRange.to, separator: ' - ' })}
          </DateRangeInput>
      }
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      { label ?
        <LabeledInput label={label} name={name}>
          <Content />
        </LabeledInput>
        :
        <Content />
      }
    </React.Fragment>
  );
}

export default translate()(DateRangePickerInput);



// WEBPACK FOOTER //
// ./src/statsradio/components/ui/forms/DateRangePickerInput.js